<script setup lang="ts">
import HandleQueryStatus from "@/components/HandleQueryStatus.vue";
import TabNav from "@/components/TabNav.vue";
import ManagementLayout from "@/layouts/ManagementLayout.vue";
import { RouterLink, RouterView } from "vue-router";
import {
  useGetCanvass,
  usePublishCanvass,
  useUnpublishCanvass,
} from "./canvassesCrud";
import PublishButton from "./PublishButton.vue";

const props = defineProps<{
  id: string;
}>();

const { canvass, getCanvassStatus } = useGetCanvass(props.id);
const { publishCanvass } = usePublishCanvass(props.id);
const { unpublishCanvass } = useUnpublishCanvass(props.id);
</script>
<template>
  <ManagementLayout
    :breadcrumbs="[
      { label: 'Haustüraktionen', to: { name: 'canvasses' } },
      { label: canvass?.name ?? '...' },
    ]"
  >
    <template #header>
      <div class="row">
        <h1 class="title">
          {{ canvass?.name }}
          <span v-if="canvass?.public" class="badge badge-success"
            >Öffentlich</span
          >
          <span v-else class="badge">Intern</span>
        </h1>
        <div v-if="canvass !== undefined" class="row-self-space-auto">
          <PublishButton
            :canvass="canvass"
            @publish="publishCanvass"
            @unpublish="unpublishCanvass"
          />
        </div>
      </div>
    </template>
    <HandleQueryStatus :query-status="getCanvassStatus">
      <TabNav>
        <li>
          <RouterLink
            :to="{
              name: 'editCanvass',
              params: { id: props.id },
            }"
            >Allgemeine Daten</RouterLink
          >
        </li>
        <li>
          <RouterLink
            :to="{
              name: 'canvassParticipants',
              params: { id: props.id },
            }"
            >Teilnehmer:innen</RouterLink
          >
        </li>
        <li>
          <RouterLink
            :to="{
              name: 'canvassStats',
              params: { id: props.id },
            }"
            >Auswertung</RouterLink
          >
        </li>
      </TabNav>
      <RouterView v-slot="{ Component }">
        <KeepAlive>
          <component :is="Component" :canvass="canvass"></component>
        </KeepAlive>
      </RouterView>
    </HandleQueryStatus>
  </ManagementLayout>
</template>

<style scoped>
.title {
  overflow-wrap: anywhere;
}
</style>
